import useSWR from 'swr';
import { useAuth } from '../contexts/AuthContext';
import { useApiClient } from '../utils/apiClient';

// Test comment for useCustomers
export interface Customer {
  id: string;
  first_name: string;
  last_name: string;
  company_name?: string;
  display_name?: string;
  email: string;
  phone?: string;
  billing_addr_line1?: string;
  billing_addr_city?: string;
  billing_addr_state?: string;
  billing_addr_zip?: string;
  billing_addr_country?: string;
  shipping_same_as_billing?: boolean;
  shipping_addr_line1?: string;
  shipping_addr_city?: string;
  shipping_addr_state?: string;
  shipping_addr_zip?: string;
  shipping_addr_country?: string;
  notes?: string;
  tax_exempt?: boolean;
  created_at?: string;
  updated_at?: string;
  starting_balance?: number;
}

export function useCustomers() {
  const { currentBusiness } = useAuth();
  const api = useApiClient();
  
  const fetcher = ([url]: [string, string]) => {
    return api.get(url);
  };

  const { data, error, mutate } = useSWR(
    currentBusiness ? ['/customers', currentBusiness.id] : null,
    fetcher
  );

  const customers = Array.isArray(data) ? data : [];
  const customersById: Record<string, Customer> = {};
  customers.forEach(c => { customersById[c.id] = c; });

  const createCustomer = async (customer: Partial<Customer>): Promise<Customer> => {
    const response = await api.post<Customer>('/customers', customer);
    await mutate();
    return response as Customer;
  };

  const updateCustomer = async (id: string, updates: Partial<Customer>): Promise<Customer> => {
    const response = await api.put<Customer>(`/customers/${id}`, updates);
    await mutate();
    return response as Customer;
  };

  const deleteCustomer = async (id: string): Promise<void> => {
    await api.delete<void>(`/customers/${id}`);
    await mutate();
  };

  return {
    customers,
    customersById,
    error,
    mutate,
    createCustomer,
    updateCustomer,
    deleteCustomer,
  };
} 